/* src/modules/locations/cards/AddLocationCard/action_types.js */

export const LOCATION_NAME_CHANGED = 'LOCATION_NAME_CHANGED';
export const LOCATION_ADDRESS_CHANGED = 'LOCATION_ADDRESS_CHANGED';
export const LOCATION_CITY_CHANGED = 'LOCATION_CITY_CHANGED';
export const LOCATION_TYPE_CHANGED = 'LOCATION_TYPE_CHANGED';
export const LOCATION_LONGITUDE_CHANGED = 'LOCATION_LONGITUDE_CHANGED';
export const LOCATION_LATITUDE_CHANGED = 'LOCATION_LATITUDE_CHANGED';

export const CLEAR_LOCATION_FIELDS = 'CLEAR_LOCATION_FIELDS';



// WEBPACK FOOTER //
// ./src/modules/locations/cards/AddLocationCard/action_types.js